import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const navItems = [
  { to: '/', label: '首页' },
  { to: '/archive', label: '反转档案' },
  { to: '/about', label: '关于我们' },
  { to: '/faq', label: '常见问题' },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? 'border-b border-background-300 bg-background-50/95 backdrop-blur' : 'bg-background-50'
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between gap-6 px-4 md:h-[72px] md:px-6">
        <Link to="/" className="flex items-center gap-2.5" aria-label="真相回旋镖首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-arrow-go-back-line text-lg" aria-hidden="true" />
          </span>
          <span className="flex flex-col leading-none">
            <strong className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              真相回旋镖
            </strong>
            <span className="mt-0.5 text-[11px] font-label text-foreground-500">
              爆料反转 · 辟谣澄清
            </span>
          </span>
        </Link>

        <nav aria-label="主导航" className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `cursor-pointer rounded-md px-3.5 py-2 text-sm font-medium font-label whitespace-nowrap transition-colors ${
                  isActive
                    ? 'bg-primary-100 text-primary-800'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/archive"
            className="flex items-center gap-1.5 rounded-md border border-background-300 px-3.5 py-2 text-sm font-medium font-label text-foreground-700 whitespace-nowrap transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-search-line" aria-hidden="true" />
            查案例
          </Link>
          <Link
            to="/about#contact"
            className="rounded-md bg-primary-500 px-4 py-2 text-sm font-medium font-label text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            提交线索
          </Link>
        </div>

        <button
          type="button"
          aria-label={open ? '关闭菜单' : '打开菜单'}
          aria-expanded={open}
          onClick={() => setOpen((prev) => !prev)}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true" />
        </button>
      </div>

      {open ? (
        <div className="border-t border-background-300 bg-background-50 md:hidden">
          <nav aria-label="移动端导航" className="flex flex-col gap-1 px-4 py-4">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm font-medium font-label transition-colors ${
                    isActive ? 'bg-primary-100 text-primary-800' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/about#contact"
              className="mt-2 rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium font-label text-background-50"
            >
              提交线索
            </Link>
          </nav>
        </div>
      ) : null}
    </header>
  );
}